import * as angular from "angular";
import {IQService} from "angular";

export class CoordinationsService {

  /* @ngInject */
  constructor(private $q: IQService) {
  }

  getTimeSlots() {
    const deferred = this.$q.defer();

    const timeSlots = [
      {
        fromHour : 8,
        fromMinute : 0,
        toHour : 11,
        toMinute : 0
      },
      {
        fromHour : 9,
        fromMinute : 0,
        toHour : 12,
        toMinute : 0
      },
      {
        fromHour : 10,
        fromMinute : 0,
        toHour : 13,
        toMinute : 0
      },
      {
        fromHour : 12,
        fromMinute : 0,
        toHour : 15,
        toMinute : 0
      },
      {
        fromHour : 14,
        fromMinute : 0,
        toHour : 17,
        toMinute : 0
      },
      {
        fromHour : 16,
        fromMinute : 0,
        toHour : 19,
        toMinute : 0
      }
    ];
    deferred.resolve(timeSlots);

    return deferred.promise;
  }

}

angular
  .module('bringoz.admin.coordinations')
  .service('coordinationsService', CoordinationsService);
